module.exports = __webpack_public_path__ + "static/media/icon_webArchive.b9950258.svg";